import { Box } from "@mui/material"
import { FunctionField, ImageField, TextField } from "react-admin"
import { InvoiceReadModel } from "../../../GeneratedClients/FreeBillApi"

const HeaderComponent = () => {

  const FONTSIZE = 11
  const COLOR = 'grey'

  return (
    <Box color={COLOR} justifyContent={'space-between'} display={'flex'} alignItems={"flex-end"}>
      <Box position={"relative"}>
        <ImageField sx={{position: "absolute", bottom: -10, left: 0}} source="logoAsBase64" />
      </Box>
      <Box textAlign={'end'} alignItems={"end"}>
        <TextField fontSize={FONTSIZE} display={'block'} source="invoiceIssuer.company.companyName" />
        <TextField fontSize={FONTSIZE} display={'block'} source="invoiceIssuer.company.street" />
        <FunctionField fontSize={FONTSIZE} display={'block'} render={(invoice: InvoiceReadModel) => `${invoice.invoiceIssuer?.company?.postCode} ${invoice.invoiceIssuer?.company?.city}`} />
        <TextField fontSize={FONTSIZE} display={'block'} source="invoiceIssuer.company.country" />
        <TextField fontSize={FONTSIZE} display={'block'} source="invoiceIssuer.taxInfo" />
      </Box>
    </Box>
  )
}

export default HeaderComponent